export default __webpack_public_path__ + "static/media/Snd_LowerWSlidedown.aa56c70d.mp3";